import { render, staticRenderFns } from "./SurveyUser.vue?vue&type=template&id=4955c40c"
import script from "./SurveyUser.vue?vue&type=script&lang=js"
export * from "./SurveyUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports